
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PaymentSuccess extends Vue {
    timeLeft = 10;
    private timer: number | null = null;

    get titleText() {
        return this.$_(
            this.isSuccess
                ? "w_PaymentSuccess_TitleSuccess"
                : "w_PaymentSuccess_TitleFailed",
        );
    }

    get descText() {
        return this.$_(
            this.isSuccess
                ? "w_PaymentSuccess_DescSuccess"
                : "w_PaymentSuccess_DescFailed",
        );
    }

    get query() {
        return (this.$route?.query ?? {}) as Record<string, any>;
    }

    get rtnCode() {
        const value = this.query.RtnCode ?? this.query.rtncode;
        return value != null ? String(value) : "";
    }

    get isSuccess() {
        return this.rtnCode === "1";
    }

    get merchantTradeNoDisplay() {
        const value =
            this.query.MerchantTradeNo ??
            this.query.merchant_trade_no ??
            this.query.merchantTradeNo;
        return value ? `#${String(value)}` : "-";
    }

    get paymentTypeDisplay() {
        const value =
            this.query.PaymentType ??
            this.query.payment_type ??
            this.query.paymentType;
        return value ? String(value) : this.$_("w_PaymentSuccess_PaymentTypeDefault");
    }

    get paymentDateDisplay() {
        const value =
            this.query.PaymentDate ??
            this.query.payment_date ??
            this.query.paymentDate;
        return value ? String(value) : "-";
    }

    get tradeNoDisplay() {
        const value =
            this.query.TradeNo ?? this.query.trade_no ?? this.query.tradeNo;
        return value ? String(value) : "-";
    }

    private formatTwd(value: any) {
        const num = Number(value ?? 0);
        if (!Number.isFinite(num) || num <= 0) return "-";
        return new Intl.NumberFormat("zh-TW", {
            style: "currency",
            currency: "TWD",
            maximumFractionDigits: 0,
        }).format(num);
    }

    private formatPoints(value: any) {
        const num = Number(value ?? 0);
        if (!Number.isFinite(num) || num <= 0) return "-";
        return `${Math.ceil(num).toLocaleString()} ${this.$_("w_PointUnit")}`;
    }

    get paidAmountDisplay() {
        const value =
            this.query.TradeAmt ?? this.query.trade_amt ?? this.query.paidAmount;
        return this.formatTwd(value);
    }

    get creditedAmountDisplay() {
        const value =
            this.query.CustomField2 ??
            this.query.customfield2 ??
            this.query.amount ??
            this.query.creditAmount ??
            this.query.TradeAmt;
        return this.formatPoints(value);
    }

    get discountAmountDisplay() {
        const credited = Number(
            this.query.CustomField2 ??
                this.query.customfield2 ??
                this.query.amount ??
                this.query.creditAmount ??
                0,
        );
        const paid = Number(
            this.query.TradeAmt ?? this.query.trade_amt ?? this.query.paidAmount ?? 0,
        );
        if (!Number.isFinite(credited) || !Number.isFinite(paid)) return "-";
        const diff = credited - paid;
        if (diff <= 0) return "-";
        return this.formatTwd(diff);
    }

    get rtnMsgDisplay() {
        const value = this.query.RtnMsg ?? this.query.rtnmsg ?? this.query.rtnMsg;
        return value ? String(value) : "-";
    }

    mounted() {
        this.timer = window.setInterval(() => {
            this.timeLeft = Math.max(0, this.timeLeft - 1);
            if (this.timeLeft <= 0) {
                this.stopTimer();
                this.closeCurrentWindow();
            }
        }, 1000);
    }

    beforeDestroy() {
        this.stopTimer();
    }

    private stopTimer() {
        if (this.timer != null) {
            window.clearInterval(this.timer);
            this.timer = null;
        }
    }

    closeCurrentWindow() {
        window.close();

        window.setTimeout(() => {
            const btn = document.querySelector(".btn-close-window") as HTMLElement | null;
            const text = document.querySelector(".countdown-text") as HTMLElement | null;
            if (btn) {
                btn.innerHTML = `<i class="fas fa-check mr-2"></i> ${this.$_(
                    "w_PaymentSuccess_CloseManual",
                )}`;
                btn.style.background = "#8898aa";
                btn.style.boxShadow = "none";
            }
            if (text) {
                text.innerHTML = this.$_("w_PaymentSuccess_CloseManualDesc");
            }
        }, 300);
    }
}
